import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LOCAL_STORAGE, WINDOW } from '@ng-toolkit/universal';
import { DriveService } from 'src/app/services/drive/drive.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  
  facebookUrl : string = environment.facebookUrl;
  message: string ;
  displayMsg: any;
  constructor(@Inject(WINDOW) private window: Window , 
  private driveSerives : DriveService) { }

  ngOnInit() {
    this.driveSerives.currentMessage.subscribe(
      message => {
        this.message = message;
        console.log("this.message: ", this.message);
      }     
      )
   if(this.message === ''){
     this.displayMsg = 'We will get back to you with recruitment schedule...'
   }else{
     this.displayMsg = this.message;
   }
  }
 
  navigateTo() {
    this.window.open(this.facebookUrl, '_blank');
   }

}
